// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
.k-form fieldset.dataCaptureSection {
  margin-top: 24px;
}
.k-form fieldset.dataCaptureSection > div > .k-checkbox-label p {
  margin-top: 10px;
  word-break: break-word;
}
.k-form fieldset.dataCaptureSection > div > .k-checkbox-label p:first-child {
  margin-top: 0;
}
.k-form fieldset.dataCaptureSection:first-child {
  margin-top: 24px;
}
@media (max-width: 599px) {
  .k-form fieldset.dataCaptureSection:first-child {
    margin-top: 30px;
  }
}
.k-form .dataCaptureSection .k-form-field .label,
.k-form .arrayItem .k-form-field .label {
  margin-top: 0;
}
.k-form .dataCaptureSection .k-form-field .label.inlineLabel,
.k-form .arrayItem .k-form-field .label.inlineLabel {
  display: inline-block;
}
.k-form .dataCaptureSection .k-form-field .label.secondLabel,
.k-form .arrayItem .k-form-field .label.secondLabel {
  color: #19419b;
  margin-left: 10px;
  font-size: 13px;
  line-height: 15px;
  cursor: pointer;
}
.k-form .dataCaptureSection .k-form-field .label.secondLabel:hover,
.k-form .arrayItem .k-form-field .label.secondLabel:hover {
  opacity: 1;
}
.k-form .dataCaptureSection .k-form-field label,
.k-form .arrayItem .k-form-field label {
  font-weight: 700;
  line-height: 16px;
}
.k-form .dataCaptureSection .k-form-field .k-checkbox-label,
.k-form .arrayItem .k-form-field .k-checkbox-label {
  font-weight: 400;
}
.k-form .arrayItem .k-form-field {
  max-width: 100%;
}
.k-form .arrayItem .sectionContainer {
  text-align: left;
}
.k-form .arrayItem .sectionContainer p {
  vertical-align: -webkit-baseline-middle;
}
@media (max-width: 845px) {
  .k-form .arrayItem .k-form-field {
    padding: 0 16px;
  }
}
.k-form .dataCaptureSection:not(.noStyle),
.k-form .arrayItem {
  text-align: left;
  padding: 0;
  margin-bottom: 20px;
}
.k-form .dataCaptureSection:not(.noStyle) legend,
.k-form .arrayItem legend {
  font-size: 13px;
  line-height: 16px;
  text-transform: uppercase;
  opacity: 0.65;
  color: #262626;
  margin: 0 0 9px 0;
  text-align: left;
  padding: 12px 16px 0 16px;
  background-color: #f8f7f3;
  width: 100%;
  font-weight: 400;
}
.k-form .dataCaptureSection:not(.noStyle) > div:empty,
.k-form .arrayItem > div:empty {
  display: none;
}
.k-form .dataCaptureSection:not(.noStyle) > div,
.k-form .arrayItem > div,
.k-form .dataCaptureSection:not(.noStyle) .sectionContainer,
.k-form .arrayItem .sectionContainer {
  border: 1px solid rgba(38, 38, 38, 0.2);
  border-radius: 8px;
  background-color: #fff;
}
.k-form .dataCaptureSection:not(.noStyle) > div .addButton,
.k-form .arrayItem > div .addButton,
.k-form .dataCaptureSection:not(.noStyle) .sectionContainer .addButton,
.k-form .arrayItem .sectionContainer .addButton {
  margin: 0;
  font-size: 14px;
}
.k-form .dataCaptureSection:not(.noStyle) > div .addButton span,
.k-form .arrayItem > div .addButton span,
.k-form .dataCaptureSection:not(.noStyle) .sectionContainer .addButton span,
.k-form .arrayItem .sectionContainer .addButton span {
  line-height: 20px;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field,
.k-form .arrayItem .k-form-field {
  display: block;
  margin: 0 0 24px 0;
  /* This is a hack to stop drop down lists inside of file fields from having the wrong width. */
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-form-field,
.k-form .arrayItem .k-form-field .k-form-field {
  width: 100%;
}
@media (max-width: 845px) {
  .k-form .dataCaptureSection:not(.noStyle) .k-form-field,
  .k-form .arrayItem .k-form-field {
    width: 100%;
  }
  .k-form .dataCaptureSection:not(.noStyle) .k-form-field:nth-child(odd):last-child,
  .k-form .arrayItem .k-form-field:nth-child(odd):last-child {
    margin-bottom: 0;
  }
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field.hidden,
.k-form .arrayItem .k-form-field.hidden {
  display: none;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-dropdown-wrap,
.k-form .arrayItem .k-form-field .k-dropdown-wrap {
  border-radius: 8px;
  height: 36px;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-searchbar,
.k-form .arrayItem .k-form-field .k-searchbar {
  border-radius: 7px 0 0 7px;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-select,
.k-form .arrayItem .k-form-field .k-select {
  border-radius: 0 7px 7px 0;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-dropdown .k-dropdown-wrap,
.k-form .arrayItem .k-form-field .k-dropdown .k-dropdown-wrap {
  overflow: hidden;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-dropdown .k-dropdown-wrap .k-input,
.k-form .arrayItem .k-form-field .k-dropdown .k-dropdown-wrap .k-input,
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-dropdown .k-dropdown-wrap .k-select,
.k-form .arrayItem .k-form-field .k-dropdown .k-dropdown-wrap .k-select {
  background-color: #f8f7f3;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-dropdown .k-dropdown-wrap .k-input,
.k-form .arrayItem .k-form-field .k-dropdown .k-dropdown-wrap .k-input {
  height: 100%;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-combobox,
.k-form .arrayItem .k-form-field .k-combobox {
  border-radius: 7px;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-combobox .k-dropdown-wrap .k-clear-value,
.k-form .arrayItem .k-form-field .k-combobox .k-dropdown-wrap .k-clear-value {
  top: 6px;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-combobox .k-dropdown-wrap .k-searchbar,
.k-form .arrayItem .k-form-field .k-combobox .k-dropdown-wrap .k-searchbar {
  background: #f8f7f3;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-textbox,
.k-form .arrayItem .k-form-field .k-textbox {
  max-width: unset;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field textarea.k-textbox,
.k-form .arrayItem .k-form-field textarea.k-textbox {
  height: auto;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-checkbox-label,
.k-form .arrayItem .k-form-field .k-checkbox-label {
  opacity: 1;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field #customFields.iAmKnownByASingleName:checked,
.k-form .arrayItem .k-form-field #customFields.iAmKnownByASingleName:checked {
  background-color: red;
  color: black;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .fileUploadField,
.k-form .arrayItem .k-form-field .fileUploadField {
  margin: 0;
  padding: 0;
  width: 100%;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-form-field,
.k-form .arrayItem .k-form-field .k-form-field {
  padding: 0;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .noticeMessage,
.k-form .arrayItem .k-form-field .noticeMessage {
  max-width: 100%;
}
.k-form .dataCaptureSection:not(.noStyle) .k-form-field .monthYearField,
.k-form .arrayItem .k-form-field .monthYearField {
  margin: 0;
}
.k-form .dataCaptureSection:not(.noStyle) .sendButton,
.k-form .arrayItem .sendButton,
.k-form .dataCaptureSection:not(.noStyle) .cancelButton,
.k-form .arrayItem .cancelButton {
  width: 100px;
}
.k-form .dataCaptureSection:not(.noStyle) .sendButton,
.k-form .arrayItem .sendButton {
  margin-left: 10px;
}
@media (min-width: 846px) {
  .k-form .dataCaptureSection:not(.noStyle),
  .k-form .arrayItem {
    text-align: left;
  }
  .k-form .dataCaptureSection:not(.noStyle) legend,
  .k-form .arrayItem legend {
    padding-left: 0;
  }
  .k-form .dataCaptureSection:not(.noStyle) > div,
  .k-form .arrayItem > div {
    padding: 17px;
  }
  .k-form .dataCaptureSection:not(.noStyle) > div .question,
  .k-form .arrayItem > div .question {
    margin: 7px 0 15px 0;
  }
  .k-form .dataCaptureSection:not(.noStyle) .sectionContainer,
  .k-form .arrayItem .sectionContainer {
    padding: 24px 17px 32px 17px;
  }
  .k-form .dataCaptureSection:not(.noStyle) > div .k-form-field,
  .k-form .arrayItem > div .k-form-field,
  .k-form .dataCaptureSection:not(.noStyle) .sectionContainer .k-form-field,
  .k-form .arrayItem .sectionContainer .k-form-field {
    padding: 0;
  }
  .k-form .dataCaptureSection:not(.noStyle) > div > .k-form-field:nth-child(2),
  .k-form .arrayItem > div > .k-form-field:nth-child(2),
  .k-form .dataCaptureSection:not(.noStyle) .sectionContainer > .k-form-field:nth-child(2),
  .k-form .arrayItem .sectionContainer > .k-form-field:nth-child(2) {
    margin-top: 7px;
  }
  .k-form .dataCaptureSection:not(.noStyle) > div > .k-form-field:last-child,
  .k-form .arrayItem > div > .k-form-field:last-child,
  .k-form .dataCaptureSection:not(.noStyle) .sectionContainer > .k-form-field:last-child,
  .k-form .arrayItem .sectionContainer > .k-form-field:last-child,
  .k-form .dataCaptureSection:not(.noStyle) > div > .k-form-field:nth-last-child(2),
  .k-form .arrayItem > div > .k-form-field:nth-last-child(2),
  .k-form .dataCaptureSection:not(.noStyle) .sectionContainer > .k-form-field:nth-last-child(2),
  .k-form .arrayItem .sectionContainer > .k-form-field:nth-last-child(2) {
    margin-bottom: 15px;
  }
  .k-form .dataCaptureSection:not(.noStyle) > div > .k-form-field:last-child.actionButtons,
  .k-form .arrayItem > div > .k-form-field:last-child.actionButtons,
  .k-form .dataCaptureSection:not(.noStyle) .sectionContainer > .k-form-field:last-child.actionButtons,
  .k-form .arrayItem .sectionContainer > .k-form-field:last-child.actionButtons,
  .k-form .dataCaptureSection:not(.noStyle) > div > .k-form-field:nth-last-child(2).actionButtons,
  .k-form .arrayItem > div > .k-form-field:nth-last-child(2).actionButtons,
  .k-form .dataCaptureSection:not(.noStyle) .sectionContainer > .k-form-field:nth-last-child(2).actionButtons,
  .k-form .arrayItem .sectionContainer > .k-form-field:nth-last-child(2).actionButtons {
    margin-bottom: 0;
  }
  .k-form .dataCaptureSection:not(.noStyle) .k-form-field,
  .k-form .arrayItem .k-form-field {
    display: inline-block;
    vertical-align: top;
    margin: 10px 15px 10px 15px;
  }
  .k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-form-field,
  .k-form .arrayItem .k-form-field .k-form-field {
    margin-left: 0;
  }
  .k-form .dataCaptureSection:not(.noStyle) .k-form-field .StripeElement,
  .k-form .arrayItem .k-form-field .StripeElement,
  .k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-dropdown,
  .k-form .arrayItem .k-form-field .k-dropdown,
  .k-form .dataCaptureSection:not(.noStyle) .k-form-field .k-combobox,
  .k-form .arrayItem .k-form-field .k-combobox,
  .k-form .dataCaptureSection:not(.noStyle) .k-form-field label.inlineLabel,
  .k-form .arrayItem .k-form-field label.inlineLabel {
    width: unset;
  }
  .k-form .dataCaptureSection:not(.noStyle) .k-form-field.longText,
  .k-form .arrayItem .k-form-field.longText {
    width: 650px;
  }
  .k-form .dataCaptureSection:not(.noStyle) .k-form-field .monthYearField .k-dropdown,
  .k-form .arrayItem .k-form-field .monthYearField .k-dropdown {
    width: 154px;
  }
  .k-form .dataCaptureSection:not(.noStyle) .k-form-field:nth-child(odd):last-child .k-checkbox-label,
  .k-form .arrayItem .k-form-field:nth-child(odd):last-child .k-checkbox-label {
    top: 0;
  }
  .k-form .dataCaptureSection:not(.noStyle) .documentFieldDropdownlist,
  .k-form .arrayItem .documentFieldDropdownlist {
    margin-left: 0;
  }
  .k-form .dataCaptureSection:not(.noStyle) #additionalNamesSection > .arrayItem,
  .k-form .arrayItem #additionalNamesSection > .arrayItem,
  .k-form .dataCaptureSection:not(.noStyle) #addressHistorySection > .arrayItem,
  .k-form .arrayItem #addressHistorySection > .arrayItem,
  .k-form .dataCaptureSection:not(.noStyle) #additionalNamesSection > legend,
  .k-form .arrayItem #additionalNamesSection > legend,
  .k-form .dataCaptureSection:not(.noStyle) #addressHistorySection > legend,
  .k-form .arrayItem #addressHistorySection > legend {
    margin-top: 24px;
  }
}
@media (max-width: 845px) {
  .k-form .dataCaptureSection:not(.noStyle) legend,
  .k-form .arrayItem legend {
    opacity: 1;
    color: rgba(38, 38, 38, 0.65);
    margin-bottom: 5px;
  }
  .k-form .dataCaptureSection:not(.noStyle) > div,
  .k-form .arrayItem > div,
  .k-form .dataCaptureSection:not(.noStyle) .sectionContainer,
  .k-form .arrayItem .sectionContainer {
    padding: 16px 15px 24px 15px;
    background-color: #fff;
    max-width: 320px;
    width: 100%;
  }
  .k-form .dataCaptureSection:not(.noStyle) > div .addButton,
  .k-form .arrayItem > div .addButton,
  .k-form .dataCaptureSection:not(.noStyle) .sectionContainer .addButton,
  .k-form .arrayItem .sectionContainer .addButton {
    color: #19419b;
    background-color: #e1e6f2;
    font-size: 14px;
  }
  .k-form .dataCaptureSection:not(.noStyle) > div .addButton span,
  .k-form .arrayItem > div .addButton span,
  .k-form .dataCaptureSection:not(.noStyle) .sectionContainer .addButton span,
  .k-form .arrayItem .sectionContainer .addButton span {
    line-height: 20px;
  }
}
.k-form-divider {
  margin: 15px;
}
/* TODO: Move this into a new file: MessageBox.less */
.dataCapturePageMessage.genericPageMessage {
  position: relative;
  padding: 8px;
  margin-bottom: 24px;
  background-color: #ffe7db;
  border-radius: 4px;
  text-align: left;
}
.dataCapturePageMessage.genericPageMessage.error {
  background-color: #ffd5d8;
  border: 1px solid #c70011;
  color: #c70011;
}
.dataCapturePageMessage.genericPageMessage.warning {
  background-color: #ffe7db;
  border: 1px solid #c23a00;
  color: #c23a00;
}
.dataCapturePageMessage.genericPageMessage.lightWarning {
  background-color: #fff4e6;
  border: 1px solid #ffb366;
  color: #cc7a00;
}
.dataCapturePageMessage.genericPageMessage.information {
  background-color: #ffe7db;
  border: 1px solid #ffa500;
  color: #ffa500;
}
.dataCapturePageMessage.genericPageMessage.success {
  background-color: #d0edd9;
  border: 1px solid #0d772d;
  color: #0d772d;
}
.dataCapturePageMessage.genericPageMessage p {
  margin: 0;
  padding-left: 8px;
  display: inline-block;
  width: calc(100% - 20px);
  font-size: 15px;
  line-height: 15px;
}
.dataCapturePageMessage.genericPageMessage .closeButton {
  color: #262626;
  position: absolute;
  font-size: 14px;
  font-family: material;
  line-height: 14px;
  top: 8px;
  right: 8px;
}
@media (max-width: 845px) {
  .dataCapturePageMessage.genericPageMessage {
    width: calc(100% - 32px);
    margin-left: 16px;
    margin-right: 16px;
    padding: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/dataCapture/DataCaptureSection.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AARf;EACC,gBAAA;AAUD;AAXA;EAKG,gBAAA;EACA,sBAAA;AASH;AAPG;EACC,aAAA;AASJ;AAHA;EACC,gBAAA;AAKD;AAHC;EAAA;IACC,gBAAA;EAMA;AACF;AAHA;;EAIG,aAAA;AAGH;AADG;;EACC,qBAAA;AAIJ;AADG;;EACC,cAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAIJ;AAFI;;EACC,UAAA;AAKL;AAvBA;;EAwBG,gBAAA;EACA,iBAAA;AAGH;AA5BA;;EA6BG,gBAAA;AAGH;AAEA;EAEE,eAAA;AADF;AADA;EAME,gBAAA;AAFF;AAJA;EASG,uCAAA;AAFH;AAMC;EAAA;IAEE,eAAA;EAJD;AACF;AAQA;;EAEC,gBAAA;EACA,UAAA;EACA,mBAAA;AAND;AAEA;;EAOE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AALF;AAQC;;EACC,aAAA;AALF;AAQC;;;;EAEC,uCAAA;EACA,kBAAA;EACA,sBAAA;AAJF;AAAC;;;;EAOE,SAAA;EACA,eAAA;AADH;AAPC;;;;EAWG,iBAAA;AAEJ;AArCA;;EAyCE,cAAA;EACA,kBAAA;EAAA,8FAA8F;AAChG;AA3CA;;EA8CG,WAAA;AACH;AAEE;EAAA;;IACC,WAAA;EAED;EAAC;;IACC,gBAAA;EAGF;AACF;AAAE;;EACC,aAAA;AAGH;AA7DA;;EA8DG,kBAAA;EACA,YAAA;AAGH;AAlEA;;EAmEG,0BAAA;AAGH;AAtEA;;EAuEG,0BAAA;AAGH;AA1EA;;EA4EI,gBAAA;AAEJ;AA9EA;;;;EAgFK,yBAAA;AAIL;AApFA;;EAoFK,YAAA;AAIL;AAxFA;;EA0FG,kBAAA;AAEH;AA5FA;;EA8FK,QAAA;AAEL;AAhGA;;EAkGK,mBAAA;AAEL;AApGA;;EAwGG,gBAAA;AAAH;AAxGA;;EA4GG,YAAA;AAAH;AA5GA;;EAgHG,UAAA;AAAH;AAhHA;;EAoHG,qBAAA;EACA,YAAA;AAAH;AArHA;;EAyHG,SAAA;EACA,UAAA;EACA,WAAA;AAAH;AA3HA;;EA+HG,UAAA;AAAH;AA/HA;;EAsIG,eAAA;AAHH;AAnIA;;EA0IG,SAAA;AAHH;AAvIA;;;;EAgJE,YAAA;AAHF;AA7IA;;EAoJE,iBAAA;AAHF;AAMC;EAAA;;IACC,gBAAA;EAFA;EACD;;IAIE,eAAA;EADD;EAIA;;IACC,aAAA;EADD;EAAA;;IAIE,oBAAA;EAAF;EAXD;;IAgBE,4BAAA;EADD;EAIA;;;;IAGE,UAAA;EADF;EAQE;;;;IACC,eAAA;EAHH;EAME;;;;;;;;IAEC,mBAAA;EAEH;EAAG;;;;;;;;IACC,gBAAA;EASJ;EA/CD;;IA6CE,qBAAA;IACA,mBAAA;IACA,2BAAA;EAMD;EArDD;;IAkDG,cAAA;EAOF;EAzDD;;;;;;;;IAyDG,YAAA;EAUF;EAPC;;IACC,YAAA;EAUF;EAvED;;IAiEG,YAAA;EAUF;EAPC;;IACC,MAAA;EAUF;EA/ED;;IA0EE,cAAA;EASD;EAJC;;;;;;;;IAEC,gBAAA;EAYF;AACF;AARC;EAAA;;IAEE,UAAA;IACA,6BAAA;IACA,kBAAA;EAWD;EARA;;;;IAEC,4BAAA;IACA,sBAAA;IACA,gBAAA;IACA,WAAA;EAYD;EAjBA;;;;IAQE,cAAA;IACA,yBAAA;IACA,eAAA;EAeF;EAzBA;;;;IAaG,iBAAA;EAkBH;AACF;AAZA;EACC,YAAA;AAcD;AACA,qDAAqD;AAXrD;EAEC,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAYD;AAVC;EACC,yBAAA;EACA,yBAAA;EACA,cAAA;AAYF;AATC;EACC,yBAAA;EACA,yBAAA;EACA,cAAA;AAWF;AARC;EACC,yBAAA;EACA,yBAAA;EACA,cAAA;AAUF;AAPC;EACC,yBAAA;EACA,yBAAA;EACA,cAAA;AASF;AANC;EACC,yBAAA;EACA,yBAAA;EACA,cAAA;AAQF;AA5CA;EAwCE,SAAA;EACA,iBAAA;EACA,qBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;AAOF;AApDA;EAiDE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;AAMF;AAHC;EAAA;IACC,wBAAA;IACA,iBAAA;IACA,kBAAA;IACA,YAAA;EAMA;AACF","sourcesContent":["@import '../../constants.less';\n\n@fieldHorizontalMargin: 15px;\n\n.k-form fieldset.dataCaptureSection {\n\tmargin-top: 24px;\n\n\t> div > .k-checkbox-label {\n\t\tp {\n\t\t\tmargin-top: 10px;\n\t\t\tword-break: break-word;\n\n\t\t\t&:first-child {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.k-form fieldset.dataCaptureSection:first-child {\n\tmargin-top: 24px;\n\n\t@media (max-width: @phoneOnlyMaxWidth) {\n\t\tmargin-top: 30px;\n\t}\n}\n\n.k-form .dataCaptureSection,\n.k-form .arrayItem {\n\t.k-form-field {\n\t\t.label {\n\t\t\tmargin-top: 0;\n\n\t\t\t&.inlineLabel {\n\t\t\t\tdisplay: inline-block;\n\t\t\t}\n\n\t\t\t&.secondLabel {\n\t\t\t\tcolor: @brightNavy;\n\t\t\t\tmargin-left: 10px;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tline-height: 15px;\n\t\t\t\tcursor: pointer;\n\n\t\t\t\t&:hover {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\tlabel {\n\t\t\tfont-weight: @sofiaFontBold;\n\t\t\tline-height: 16px;\n\t\t}\n\n\t\t.k-checkbox-label {\n\t\t\tfont-weight: 400;\n\t\t}\n\t}\n}\n\n.k-form .arrayItem {\n\t.k-form-field {\n\t\tmax-width: 100%;\n\t}\n\n\t.sectionContainer {\n\t\ttext-align: left;\n\n\t\tp {\n\t\t\tvertical-align: -webkit-baseline-middle;\n\t\t}\n\t}\n\n\t@media (max-width: @dataCaptureOneColumnFieldsPageMaxWidth) {\n\t\t.k-form-field {\n\t\t\tpadding: 0 16px;\n\t\t}\n\t}\n}\n\n.k-form .dataCaptureSection:not(.noStyle),\n.k-form .arrayItem {\n\ttext-align: left;\n\tpadding: 0;\n\tmargin-bottom: 20px;\n\n\tlegend {\n\t\tfont-size: 13px;\n\t\tline-height: 16px;\n\t\ttext-transform: uppercase;\n\t\topacity: 0.65;\n\t\tcolor: @grey26;\n\t\tmargin: 0 0 9px 0;\n\t\ttext-align: left;\n\t\tpadding: 12px 16px 0 16px;\n\t\tbackground-color: @fieldBackgroundWhite;\n\t\twidth: 100%;\n\t\tfont-weight: 400;\n\t}\n\n\t& > div:empty {\n\t\tdisplay: none;\n\t}\n\n\t& > div,\n\t.sectionContainer {\n\t\tborder: @containerBorder;\n\t\tborder-radius: 8px;\n\t\tbackground-color: @white;\n\n\t\t.addButton {\n\t\t\tmargin: 0;\n\t\t\tfont-size: 14px;\n\n\t\t\tspan {\n\t\t\t\tline-height: 20px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.k-form-field {\n\t\tdisplay: block;\n\t\tmargin: 0 0 24px 0;\n\n\t\t/* This is a hack to stop drop down lists inside of file fields from having the wrong width. */\n\t\t.k-form-field {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t@media (max-width: @dataCaptureOneColumnFieldsPageMaxWidth) {\n\t\t\twidth: 100%;\n\n\t\t\t&:nth-child(odd):last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\n\t\t&.hidden {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t.k-dropdown-wrap {\n\t\t\tborder-radius: 8px;\n\t\t\theight: 36px;\n\t\t}\n\n\t\t.k-searchbar {\n\t\t\tborder-radius: 7px 0 0 7px;\n\t\t}\n\n\t\t.k-select {\n\t\t\tborder-radius: 0 7px 7px 0;\n\t\t}\n\n\t\t.k-dropdown {\n\t\t\t.k-dropdown-wrap {\n\t\t\t\toverflow: hidden;\n\n\t\t\t\t.k-input,\n\t\t\t\t.k-select {\n\t\t\t\t\tbackground-color: @fieldBackgroundWhite;\n\t\t\t\t}\n\n\t\t\t\t.k-input {\n\t\t\t\t\theight: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.k-combobox {\n\t\t\tborder-radius: 7px;\n\n\t\t\t.k-dropdown-wrap {\n\t\t\t\t.k-clear-value {\n\t\t\t\t\ttop: 6px;\n\t\t\t\t}\n\n\t\t\t\t.k-searchbar {\n\t\t\t\t\tbackground: @fieldBackgroundWhite;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.k-textbox {\n\t\t\tmax-width: unset;\n\t\t}\n\n\t\ttextarea.k-textbox {\n\t\t\theight: auto;\n\t\t}\n\n\t\t.k-checkbox-label {\n\t\t\topacity: 1;\n\t\t}\n\n\t\t#customFields.iAmKnownByASingleName:checked {\n\t\t\tbackground-color: red;\n\t\t\tcolor: black;\n\t\t}\n\n\t\t.fileUploadField {\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.k-form-field {\n\t\t\tpadding: 0;\n\n\t\t\t& > div {\n\t\t\t}\n\t\t}\n\n\t\t.noticeMessage {\n\t\t\tmax-width: 100%;\n\t\t}\n\n\t\t.monthYearField {\n\t\t\tmargin: 0;\n\t\t}\n\t}\n\n\t.sendButton,\n\t.cancelButton {\n\t\twidth: 100px;\n\t}\n\n\t.sendButton {\n\t\tmargin-left: 10px;\n\t}\n\n\t@media (min-width: @dataCaptureTwoColumnFieldsPageMinWidth) {\n\t\ttext-align: left;\n\n\t\tlegend {\n\t\t\tpadding-left: 0;\n\t\t}\n\n\t\t& > div {\n\t\t\tpadding: @dataCaptureContainerPadding;\n\n\t\t\t.question {\n\t\t\t\tmargin: 7px 0 15px 0;\n\t\t\t}\n\t\t}\n\n\t\t.sectionContainer {\n\t\t\tpadding: 24px @dataCaptureContainerPadding 32px @dataCaptureContainerPadding;\n\t\t}\n\n\t\t& > div,\n\t\t.sectionContainer {\n\t\t\t.k-form-field {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\n\t\t& > div,\n\t\t.sectionContainer {\n\t\t\t> .k-form-field {\n\t\t\t\t&:nth-child(2) {\n\t\t\t\t\tmargin-top: 7px;\n\t\t\t\t}\n\n\t\t\t\t&:last-child,\n\t\t\t\t&:nth-last-child(2) {\n\t\t\t\t\tmargin-bottom: 15px;\n\n\t\t\t\t\t&.actionButtons {\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.k-form-field {\n\t\t\tdisplay: inline-block;\n\t\t\tvertical-align: top;\n\t\t\tmargin: 10px @fieldHorizontalMargin 10px @fieldHorizontalMargin;\n\n\t\t\t.k-form-field {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t.StripeElement,\n\t\t\t.k-dropdown,\n\t\t\t.k-combobox,\n\t\t\tlabel.inlineLabel {\n\t\t\t\twidth: unset;\n\t\t\t}\n\n\t\t\t&.longText {\n\t\t\t\twidth: 650px;\n\t\t\t}\n\n\t\t\t.monthYearField .k-dropdown {\n\t\t\t\twidth: 154px;\n\t\t\t}\n\n\t\t\t&:nth-child(odd):last-child .k-checkbox-label {\n\t\t\t\ttop: 0;\n\t\t\t}\n\t\t}\n\n\t\t.documentFieldDropdownlist {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t#additionalNamesSection,\n\t\t#addressHistorySection {\n\t\t\t& > .arrayItem,\n\t\t\t& > legend {\n\t\t\t\tmargin-top: 24px;\n\t\t\t}\n\t\t}\n\t}\n\n\t@media (max-width: @dataCaptureOneColumnFieldsPageMaxWidth) {\n\t\tlegend {\n\t\t\topacity: 1;\n\t\t\tcolor: rgba(38, 38, 38, 0.65);\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\n\t\t& > div,\n\t\t.sectionContainer {\n\t\t\tpadding: 16px 15px 24px 15px;\n\t\t\tbackground-color: @white;\n\t\t\tmax-width: @formFieldsetWidthForMobile;\n\t\t\twidth: 100%;\n\n\t\t\t.addButton {\n\t\t\t\tcolor: @buttonColorLight;\n\t\t\t\tbackground-color: @buttonBackgroundColorLight;\n\t\t\t\tfont-size: 14px;\n\n\t\t\t\tspan {\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.k-form-divider {\n\tmargin: @fieldHorizontalMargin;\n}\n\n/* TODO: Move this into a new file: MessageBox.less */\n.dataCapturePageMessage.genericPageMessage {\n\t@exclamationMarkIconSize: 20px;\n\tposition: relative;\n\tpadding: 8px;\n\tmargin-bottom: 24px;\n\tbackground-color: #ffe7db;\n\tborder-radius: 4px;\n\ttext-align: left;\n\n\t&.error {\n\t\tbackground-color: @backgroundRed;\n\t\tborder: 1px solid @statusRed;\n\t\tcolor: @statusRed;\n\t}\n\n\t&.warning {\n\t\tbackground-color: @backgroundOrange;\n\t\tborder: 1px solid @statusOrange;\n\t\tcolor: @statusOrange;\n\t}\n\n\t&.lightWarning {\n\t\tbackground-color: #fff4e6;\n\t\tborder: 1px solid #ffb366;\n\t\tcolor: #cc7a00;\n\t}\n\n\t&.information {\n\t\tbackground-color: @backgroundOrange;\n\t\tborder: 1px solid #ffa500;\n\t\tcolor: #ffa500;\n\t}\n\n\t&.success {\n\t\tbackground-color: @backgroundGreen;\n\t\tborder: 1px solid @statusGreen;\n\t\tcolor: @statusGreen;\n\t}\n\n\tp {\n\t\tmargin: 0;\n\t\tpadding-left: 8px;\n\t\tdisplay: inline-block;\n\t\twidth: calc(100% - @exclamationMarkIconSize);\n\t\tfont-size: 15px;\n\t\tline-height: 15px;\n\t}\n\n\t.closeButton {\n\t\tcolor: @labelGrey;\n\t\tposition: absolute;\n\t\tfont-size: 14px;\n\t\tfont-family: material;\n\t\tline-height: 14px;\n\t\ttop: 8px;\n\t\tright: 8px;\n\t}\n\n\t@media (max-width: @dataCaptureOneColumnFieldsPageMaxWidth) {\n\t\twidth: calc(100% - 32px);\n\t\tmargin-left: 16px;\n\t\tmargin-right: 16px;\n\t\tpadding: 8px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
